<p-toast key="app-toast" position="top-right" [baseZIndex]="5000">
  <ng-template let-message #headless let-closeFn="closeFn">
    <div class="flex items-center rounded-md shadow-sm relative gap-1.5 px-3.5 py-2"
         [ngClass]="{
           'border border-green-200 bg-green-50 text-green-600': message.severity === 'success',
           'border border-red-200 bg-red-50 text-red-600': message.severity === 'error',
           'border border-blue-200 bg-blue-50 text-blue-600': message.severity === 'information',
           'border border-yellow-200 bg-yellow-50 text-yellow-600': message.severity === 'warning'
         }"
    >
      <span class="material-icons-outlined text-base"
            [ngClass]="{
              'text-green-600': message.severity === 'success',
              'text-red-600': message.severity === 'error',
              'text-blue-600': message.severity === 'information',
              'text-yellow-600': message.severity === 'warning'
            }"
      >
        {{ message.severity === 'success' ? 'check' : 'info' }}
      </span>

      <div class="flex-1 flex flex-col gap-0.5">
        <ng-container *ngIf="message.detail">
          <span
            class="font-semibold text-base"
            [ngClass]="{
              'text-green-600': message.severity === 'success',
              'text-red-600': message.severity === 'error',
              'text-blue-600': message.severity === 'information',
              'text-yellow-600': message.severity === 'warning'
            }"
          >
            {{ message.detail }}
          </span>
        </ng-container>

        <span
          class="font-normal text-base"
          [ngClass]="{
            'text-green-600': message.severity === 'success',
            'text-red-600': message.severity === 'error',
            'text-blue-600': message.severity === 'information',
            'text-yellow-600': message.severity === 'warning'
          }"
        >
          {{ message.summary }}
          <button
            *ngIf="message?.data?.actionLabel"
            type="button"
            class="ml-1 cursor-pointer underline underline-offset-2 decoration-current"
            [ngClass]="{
              'text-green-600': message.severity === 'success',
              'text-red-600': message.severity === 'error',
              'text-blue-600': message.severity === 'information',
              'text-yellow-600': message.severity === 'warning'
            }"
            (click)="onActionClick(message, closeFn)"
          >
            {{ message.data.actionLabel }}
          </button>
        </span>
      </div>

      <button (click)="closeFn($event)"
              class="material-icons cursor-pointer text-base focus:outline-none"
              [ngClass]="{
                'text-green-600': message.severity === 'success',
                'text-red-600': message.severity === 'error',
                'text-blue-600': message.severity === 'information',
                'text-yellow-600': message.severity === 'warning'
              }"
      >
        close
      </button>
    </div>
  </ng-template>
</p-toast>
